/**
 *
 * @param params
 */
import appConfig from "../appConfig";

const __DCE_DEBUG =
  window.location?.search?.includes(
    `${appConfig.branding?.debugPrefix || "rev"}_debug=1`
  ) || false;

const __DEBUG_PREFIX = (appConfig.branding?.debugPrefix || "rev") + "_debug: ";
export const dceDebug = (...params) => {
  if (__DCE_DEBUG) {
    console.log(__DEBUG_PREFIX, ...params);
  }
};
